import {
    START_UPDATE_APP_INFO,
    FINISH_UPDATE_APP_INFO,
    UPDATE__USER__CONFIG__ENV___APP_INFO,
    UPDATE__USER
} from "./constants";

const initialState = {
    loading: false,
    organization_user: null,
    organization_id: null,
    user: false,
    config: null,
    env: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case START_UPDATE_APP_INFO:
            return {...state, ...action.payload, loading: true};

        case FINISH_UPDATE_APP_INFO:
            return {...state, loading: false};

        case UPDATE__USER__CONFIG__ENV___APP_INFO:
            return {...state, ...action.payload};

        case UPDATE__USER:
            return {...state, user: {...state.user, ...action.payload}};

        default:
            return state;
    }
};
